import React, { Component } from 'react';

function wrapperStyle({ slideLeft, styles }) {
  return {
    ...styles.toEdgeStyle,
    transform: slideLeft ? 'translateX(-25%)' : '',
    transition: 'transform 600ms ease-in-out'
  };
}

function calculateVideoWidth({ frameWidth, frameHeight }) {
  const videoHeight = frameWidth / 16 * 9;
  let videoWidth = frameWidth;

  if (videoHeight < frameHeight) {
    videoWidth = frameHeight / videoHeight * frameWidth;
  }

  return videoWidth;
}

function videoStyle({ frameWidth, frameHeight }) {
  const videoHeight = frameWidth / 16 * 9;

  const style = {
    position: 'absolute',
    top: 0
  };

  if (videoHeight < frameHeight) {
    style.left = -(frameHeight / videoHeight * frameWidth - frameWidth) / 2;
  }

  return style;
}

class VideoPlayer extends Component {
  constructor() {
    super();
    this.resetAndPlay = this.resetAndPlay.bind(this);
  }

  componentDidMount() {
    if (this.props.play && this.props.url !== '') {
      this.resetAndPlay();
    }
  }

  componentWillReceiveProps({ play: nextPlay, active: nextActive }) {
    const { url, play, active } = this.props;

    if (url !== '' && (play !== nextPlay || active !== nextActive)) {
      this.resetAndPlay();
    }
  }

  resetAndPlay() {
    if (this.video) {
      if (!this.video.paused) {
        this.video.pause();
      }
      this.video.currentTime = 0;
      this.video.play();
    } else {
      console.log('no video');
    }
  }

  render() {
    const { url, slideLeft, dimensions, autoPlay, styles } = this.props;
    const { width, height } = dimensions;

    const self = this;

    return (
      <div style={wrapperStyle({ slideLeft, styles })}>
        <video
          width={calculateVideoWidth({
            frameWidth: width,
            frameHeight: height
          })}
          style={videoStyle({
            frameWidth: width,
            frameHeight: height
          })}
          ref={video => {
            self.video = video;
          }}
          autoPlay={autoPlay}
          loop
          muted
          src={url}
        />
      </div>
    );
  }
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/index.js